import React, { useEffect, useState } from "react";
import { VegaFlex } from "@heartlandone/vega-react";
import StarRatings from 'react-star-ratings';

function Rating({ rates = [] }) {
  const [rate, setRate] = useState(0);
  const [groupedRate, setGroupedRate] = useState([]);

  const getRate = (rates) => {
    const result = rates.reduce((a, b) => a + b, 0);
    setRate(parseFloat((rates.length === 0 ? 0 : result/rates.length).toFixed(1)));
  }

  const groupRate = (rates, fn) => {
    const map = {
      5: 0,
      4: 0,
      3: 0,
      2: 0,
      1: 0
    };
    rates.forEach((r) => {
      if (map?.[`${r}`] > 0) {
        map[`${r}`] += 1
      } else {
        map[`${r}`] = 1;
      }
    });
    
    if (typeof fn === "function") {
      fn({...map});
    }
  };

  const _normalizeRate = (map = {}) => {
    const keys = Object.keys(map);
    let max = 0;
    keys.forEach((key) => {
      if(map[`${key}`] > max) {
        max = map[`${key}`];
      };
    });
    
    max > 0 && keys.forEach((key) => {
      map[`${key}`] = `${(map[`${key}`] * 100 / max).toFixed(2)}%`;
    });

    const sortedKeys = keys.sort((a, b) => {
      if (a > b) {
        return -1;
      } else if (a < b) {
        return 1;
      } else {
        return 0;
      }
    });

    setGroupedRate(sortedKeys.map((_) => ({[`${_}`]: map[`${_}`]})));
  }

  useEffect(() => {
      getRate(rates);
      groupRate(rates, _normalizeRate);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rates.length])

  return (<>
    <VegaFlex className='f-size-20 f-weight-700 line-height-28'>
      Reviews
    </VegaFlex><VegaFlex direction={"row"} gap={'size-72'}>
        <VegaFlex direction={"col"} gap={'size-8'}>
          <div className='f-size-42 f-weight-700 line-height-50'>{rate}</div>
          <StarRatings
            rating={rate}
            starRatedColor={'#FFDC83'}
            numberOfStars={5}
            name='rating'
            starEmptyColor={'rgba(4, 4, 28, 0.64)'}
            starSpacing={4}
            starDimension={18}
            svgIconViewBox='0 0 18 16'
            svgIconPath='M9.90255 0.5625C9.73692 0.21875 9.38692 0 9.00255 0C8.61817 0 8.2713 0.21875 8.10255 0.5625L6.09317 4.69688L1.60567 5.35938C1.23067 5.41563 0.91817 5.67813 0.802545 6.0375C0.68692 6.39688 0.78067 6.79375 1.04942 7.05938L4.30567 10.2813L3.53692 14.8344C3.47442 15.2094 3.63067 15.5906 3.94005 15.8125C4.24942 16.0344 4.6588 16.0625 4.9963 15.8844L9.00567 13.7438L13.015 15.8844C13.3525 16.0625 13.7619 16.0375 14.0713 15.8125C14.3807 15.5875 14.5369 15.2094 14.4744 14.8344L13.7025 10.2813L16.9588 7.05938C17.2275 6.79375 17.3244 6.39688 17.2057 6.0375C17.0869 5.67813 16.7775 5.41563 16.4025 5.35938L11.9119 4.69688L9.90255 0.5625Z' />
          <div className='f-size-12 f-weight-400 line-height-16 font-light-text-color-secondary m-t-6'>{rates.length} reviews</div>
        </VegaFlex>
        <VegaFlex direction={'col'} gap={'size-4'}>
          {
            groupedRate.map((r) => {
              const key = Object.keys(r);
              return <VegaFlex alignItems={'center'} gap={'size-8'}>
                <span>{key}</span>
                <div className='rating-bar-bg bg-light-Background-Chip relative'>
                  <div className='rating-bar bg-light-Background-Action' style={{ width: r[`${key}`] }}></div>
                </div>
              </VegaFlex>
            })
          }
        </VegaFlex>
      </VegaFlex>
    </>
  );
}

export default Rating;
